// import MobileLoginPages from "../../component/login/MobileLoginPages";
// import DesktopLogin from "../../component/login/DesktopLogin";
// import Links from "../../component/login/Links";
import Login from "../../component/login & register/Login";

const LoginComponent = () => {
  return (
    <div className="LOGIN">
      {/* <Links />
      {window.innerWidth > 1000 ? <DesktopLogin /> : <MobileLoginPages />} */}
      {window.innerWidth > 1000 && <Login mode={1} />}
      {window.innerWidth < 1000 && <Login mode={2} />}
    </div>
  );
};

export default LoginComponent;
